import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../../providers';

const useStyles = makeStyles((theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    email: {
        color: theme.palette.text.mainBlue,
    },
}));

const NoRedirectServiceDialog = ({ onAccept, open }) => {
    const classes = useStyles();
    return (
        <Dialog open={open} onClose={onAccept} aria-labelledby="reset-account-accept-dialog" className={classes.dialogOverride}>
            <DialogTitle id="form-dialog-title">{t('important.notice')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('online.services.unavailable')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onAccept}>
                    {t('ok').toUpperCase()}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NoRedirectServiceDialog;
